import React, { Component } from 'react';
import PropTypes from 'prop-types';
import MobileSearchArea from '../MobileSearchArea';
import Loader from '../Loader';
import SuggestionsList from '../SuggestionsList';
import ProductCategoriesList from '../ProductCategoriesList';
import ProductsList from '../ProductsList';
import ShowResultsBar from '../ShowResultsBar';
import PopularSearches from '../PopularSearches';
import { MIN_SEARCH_SYMBOLS_COUNT, APP_CONTAINER_ID_MOBILE } from '../../../consts';

import styles from './index.scss';

class MobileView extends Component {
    handleTouchEnd = ev => {
        // handle only scroll
        if (!this.isScrolling) {
            return;
        }
        if (!this.elSearchResults) {
            return;
        }

        const { scrollHeight, clientHeight, scrollTop } = this.elSearchResults;
        const multiTouchEvent = ev.touches.length > 1;

        // skip multitouch events
        if (multiTouchEvent) {
            return;
        }

        const maxScrollTop = scrollHeight - clientHeight;

        if (scrollTop <= 0 || scrollTop >= maxScrollTop) {
            ev.preventDefault();
        }
    };

    handleTouchStart = () => {
        this.isScrolling = false;
    };

    hadnleScroll = () => {
        this.isScrolling = true;
    };

    renderSearchResults() {
        const {
            mainState: {
                suggestions,
                searchInputValue,
                translationsMap,
                noSuggestionsFound,
                showPopularSearches,
                localeParams,
            },
        } = this.props;
        const { results: products, categories, phrase } = suggestions;

        return (
            <div
                ref={el => {
                    this.elSearchResults = el;
                }}
                className={styles.mobileSearchResults}
                onTouchStart={this.handleTouchStart}
                onScroll={this.hadnleScroll}
                onTouchEnd={this.handleTouchEnd}
            >
                {!noSuggestionsFound && (
                    <div>
                        {showPopularSearches && localeParams.cc === 'us' ? (
                            <PopularSearches />
                        ) : null}
                        {phrase && phrase.length ? (
                            <SuggestionsList phrase={phrase} searchValue={searchInputValue} />
                        ) : null}
                        {categories && categories.length ? (
                            <ProductCategoriesList
                                categories={categories}
                                translationsMap={translationsMap}
                            />
                        ) : null}
                        {products && products.length ? (
                            <ProductsList products={products} translationsMap={translationsMap} />
                        ) : null}
                    </div>
                )}
            </div>
        );
    }

    render() {
        const {
            onChange,
            onClear,
            onCancel,
            mainState: { searchInputValue, translationsMap, isLoading },
            redirectTo,
            isVisible,
            addPopularSearches,
        } = this.props;

        return (
            <div
                className={`${styles.mobileViewOverlay} ${
                    isVisible ? styles.mobileViewOverlay_visible : ''
                }`}
                id={APP_CONTAINER_ID_MOBILE}
            >
                <MobileSearchArea
                    onChange={onChange}
                    onClear={onClear}
                    onCancel={onCancel}
                    inputValue={searchInputValue}
                    translationsMap={translationsMap}
                    redirectTo={redirectTo}
                    addPopularSearches={addPopularSearches}
                />
                {isLoading ? (
                    <Loader text={translationsMap['searchBox.searching']} />
                ) : (
                    this.renderSearchResults()
                )}
                {searchInputValue.length >= MIN_SEARCH_SYMBOLS_COUNT ? (
                    <ShowResultsBar translationsMap={translationsMap} redirectTo={redirectTo} />
                ) : null}
            </div>
        );
    }
}

MobileView.propTypes = {
    onChange: PropTypes.func.isRequired,
    onClear: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    mainState: PropTypes.object.isRequired,
    redirectTo: PropTypes.func.isRequired,
    isVisible: PropTypes.bool.isRequired,
    addPopularSearches: PropTypes.func.isRequired,
};

export default MobileView;
